export const Routes = [
    {
        normal: [
            '/home',
            '/products',
            '/business-details',
            '/additional-info',
            '/review-application',
            '/payment',
            '/payment-confirmation',
        ],
        retrieveQuoteByNumber: [
            '/home',
            '/retrieve-quote',
            '/business-details',
        ],
        retrieveQuoteByEmail: [
            '/home',
            '/retrieve-quote',
            '/quote-list',
            '/business-details',
        ],
        skipPolicy: ['/additional-info', '/review-application'],
        error: '/generic-error',
    },
    {
        normal: [
            '/home',
            '/products',
            '/business-details',
            '/additional-info',
            '/review-application',
            '/payment',
            '/payment-confirmation',
        ],
        retrieveQuoteByNumber: [
            '/home',
            '/retrieve-quote',
            '/business-details',
        ],
        retrieveQuoteByEmail: [
            '/home',
            '/retrieve-quote',
            '/quote-list',
            '/business-details',
        ],
        skipPolicy: ['/additional-info', '/review-application'],
        error: '/generic-error',
    },
];
